import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PIDSimulator from "@/pages/PIDSimulator";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PIDSimulator />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
